import "./mobileAdCard.css";
import axios from "axios";
import { Image, Placeholder, Transformation } from "cloudinary-react";
import { backend } from "../../../backend";
import { createSEOUrl } from "../../../utils/createSEOUrl";
import { logAxiosError } from "../../../logging/error";
import CloseButtonV2 from "../../../components/PasswordRulesModal/CloseButtonV2";

export default function MobileAdCard({ id, props, hoverEffects, onClose }) {
  const hasImages =
    id.images && id.images.length > 0 && Object.values(id.images[0])[0];

  const handleAdClick = async () => {
    try {
      await axios.post(backend("/api/listings/click"), {
        id: id._id,
      });
    } catch (error) {
      logAxiosError(error);
    }
  };

  const noImage = () => {
    return (
      <svg
        className="mobile-slash-eye-icon"
        fill="currentColor"
        viewBox="0 0 16 16"
        {...props}
      >
        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 00-2.79.588l.77.771A5.944 5.944 0 018 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0114.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
        <path d="M11.297 9.176a3.5 3.5 0 00-4.474-4.474l.823.823a2.5 2.5 0 012.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 01-4.474-4.474l.823.823a2.5 2.5 0 002.829 2.829z" />
        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 001.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 018 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884l-12-12 .708-.708 12 12-.708.708z" />
      </svg>
    );
  };
  const locationIcon = (
    <svg width="1.5rem" height="1.5rem" viewBox="0 0 24 24" fill="#4e8157">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0036 14.0035C14.4889 14.0035 16.5036 11.9887 16.5036 9.50347C16.5036 7.01819 14.4889 5.00347 12.0036 5.00347C9.51831 5.00347 7.50359 7.01819 7.50359 9.50347C7.50359 11.9887 9.51831 14.0035 12.0036 14.0035ZM12.0036 12.0071C10.6209 12.0071 9.5 10.8862 9.5 9.50347C9.5 8.12077 10.6209 6.99988 12.0036 6.99988C13.3863 6.99988 14.5072 8.12077 14.5072 9.50347C14.5072 10.8862 13.3863 12.0071 12.0036 12.0071Z"
        fill="#4e8157"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.272 11.5818C22.5649 5.78816 18.0052 0.00354004 12 0.00354004C5.99649 0.00354004 1.43639 5.7961 2.72816 11.5825C3.72523 16.2821 7.7572 20.8465 10.1636 23.2269C11.1942 24.2463 12.8058 24.2463 13.8364 23.2269C16.2429 20.8464 20.2752 16.2816 21.272 11.5818ZM12 2.00354C16.7124 2.00354 20.3368 6.58981 19.32 11.1462C18.8316 13.3355 17.7359 15.3015 16.4501 17.119C15.1064 19.0184 13.5829 20.6644 12.4299 21.805C12.1786 22.0536 11.8214 22.0536 11.5701 21.805C10.4171 20.6645 8.89379 19.0186 7.55009 17.1193C6.26419 15.3017 5.16886 13.3361 4.68011 11.1467C3.66438 6.59682 7.29012 2.00354 12 2.00354Z"
        fill="#4e8157"
      ></path>
    </svg>
  );

  const primary =
    id.district?.replace(/-/g, " ") ||
    id.zone?.replace(/-/g, " ") ||
    id.postCode_district;

  let primaryTwo;
  if (
    primary === "Askim Frölunda Högsbo" ||
    primary === "Örgryte Härlanda" ||
    primary === "Majorna Linné"
  ) {
    primaryTwo = primary.replace(/ /g, "-");
  }

  const isSame =
    primary &&
    id.municipality &&
    primary.toLowerCase() === id.municipality.toLowerCase();

  const secondary = isSame ? id.county : id.municipality;

  const prices = [
    { value: id.hourly_rent, label: "tim" },
    { value: id.daily_rent, label: "dag" },
    { value: id.monthly_rent, label: "mån" },
    { value: id.workspace_rent, label: "plats" },
  ].filter((p) => p.value && p.value !== 0);

  prices.sort((a, b) => a.value - b.value);

  return (
    <article>
      <a
        onClick={(e) => {
          e.stopPropagation();
          handleAdClick();
        }}
        className="mobile-ad-card-outer-link"
        href={`/lediga-lokaler/${createSEOUrl(id.municipality)}/${createSEOUrl(
          id.type_of_room,
        )}/${createSEOUrl(id.address)}/${id._id}`}
      >
        <div className={`mobile-search-result-card`}>
          <div className="mobile-ad-card-top">
            <div className="mobile-ad-card-type">
              <span>{id.type_of_room}</span>
            </div>
            {onClose && <CloseButtonV2 onClick={onClose} />}
          </div>
          {hasImages ? (
            <>
              <div className="image-container">
                <Image
                  alt={
                    id.type_of_room +
                    " finns att hyra på " +
                    id.address +
                    " i " +
                    id.municipality
                  }
                  cloudName="vakansa"
                  publicId={`listings/${id._id}/${id.images[0]}`}
                  responsive
                  dpr="auto"
                  crop="scale"
                  quality="auto"
                  style={{ margin: "0 auto" }}
                  className="mobile-adcard-image"
                >
                  <Transformation quality="auto:best" fetchFormat="auto" />
                  <Placeholder type="predominant" />
                </Image>
              </div>
            </>
          ) : (
            <div className="mobile-adcard-no-image">
              {noImage()}
              <span>Bild inte tillgänglig</span>
            </div>
          )}

          <div className="mobile-search-ad-card">
            <div className="mobile-search-ad-card-heading">
              <h3>
                {id.address.charAt(0).toUpperCase() +
                  id.address.slice(1).toLowerCase()}
              </h3>
              <div>
                <p>
                  {locationIcon}
                  {primaryTwo || primary}
                  {secondary ? `, ${secondary}` : ""}
                </p>
              </div>
            </div>
            <div className="mobile-search-ad-card-price">
              {prices.map((p, index) => (
                <span key={index}>
                  {p.value} kr /{p.label}
                </span>
              ))}
            </div>
          </div>
        </div>
      </a>
    </article>
  );
}
